import React from 'react';
import {Calendar} from 'lucide-react';

interface DateWithRelativeProps {
  timestamp: number; // Unix timestamp in milliseconds
  showIcon?: boolean;
}

export function DateWithRelative({timestamp, showIcon = true}: DateWithRelativeProps) {
  // Format the date
  const date = new Date(timestamp);
  const formattedDate = date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  // Calculate relative time
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffDays / 365);

  let relativeTime: string;
  if (diffYears > 0) {
    relativeTime = `${diffYears} ${diffYears === 1 ? 'year' : 'years'} ago`;
  } else if (diffMonths > 0) {
    relativeTime = `${diffMonths} ${diffMonths === 1 ? 'month' : 'months'} ago`;
  } else if (diffWeeks > 0) {
    relativeTime = `${diffWeeks} ${diffWeeks === 1 ? 'week' : 'weeks'} ago`;
  } else if (diffDays > 0) {
    relativeTime = `${diffDays} ${diffDays === 1 ? 'day' : 'days'} ago`;
  } else {
    relativeTime = 'today';
  }

  return (
    <div className="flex items-start gap-2">
      {showIcon && <Calendar className="text-gray-400 dark:text-gray-500 flex-shrink-0 mt-0.5" size={16} />}
      <div className="flex flex-col">
        <span className="text-sm text-gray-900 dark:text-gray-100">{formattedDate}</span>
        <span className="text-xs italic text-gray-500 dark:text-gray-400">{relativeTime}</span>
      </div>
    </div>
  );
}
